import React, { useState } from "react";
import { Paper, Box, Typography, Stack } from "@mui/material";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import CreditCardRoundedIcon from "@mui/icons-material/CreditCardRounded";
import HomeWorkRoundedIcon from "@mui/icons-material/HomeWorkRounded";
import CalendarMonthRoundedIcon from "@mui/icons-material/CalendarMonthRounded";
import VolunteerActivismRoundedIcon from "@mui/icons-material/VolunteerActivismRounded";
import { useNavigate, useParams } from "react-router-dom";

import { getRuta } from "../../../helpers/Helpers";
import CreditDetails from "./CreditDetails";
import CreditGarantias from "./CreditGarantias";
import CreditPayment from "./CreditPayment";
import CreditAbono from "./CreditAbono";
import SegmentedTabs from "../../../components/ui/SegmentedTabs";
import StatusChip from "../../../components/ui/StatusChip";
import { monoFont } from "../../../theme";
import moment from "moment";

const estadoCredito = (dataCredit) => {
  if (!dataCredit) {
    return { label: "", tone: "neutral" };
  }
  if (dataCredit.isCanceled) {
    return { label: "Cancelado", tone: "neutral" };
  }
  if (!dataCredit.isEntregado) {
    return { label: "Pendiente", tone: "info" };
  }
  const vencido = moment(dataCredit.fechaVencimiento).isBefore(moment(), "day");
  return vencido ? { label: "Vencido", tone: "error" } : { label: "Al día", tone: "success" };
};

const initials = (fullName) => {
  const parts = (fullName || "").trim().split(/\s+/);
  return `${(parts[0] || "")[0] || ""}${(parts[1] || "")[0] || ""}`.toUpperCase();
};

const CreditDetailsContainer = () => {
  let ruta = getRuta();
  let navigate = useNavigate();
  const { id } = useParams();
  const [value, setValue] = useState(0);
  const [clientName, setClientName] = useState("");
  const [dataCredit, setDataCredit] = useState("");
  const [isNominal, setIsNominal] = useState(false);

  const estado = estadoCredito(dataCredit);

  return (
    <div>
      <Box
        onClick={() => navigate(`${ruta}/credits`)}
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: "6px",
          color: "text.disabled",
          fontSize: 13,
          fontWeight: 500,
          marginBottom: "16px",
          cursor: "pointer",
          "&:hover": { color: "#00a152" },
        }}
      >
        <ArrowBackRoundedIcon sx={{ fontSize: 19 }} />
        Volver a créditos
      </Box>

      <Paper sx={{ padding: "22px 24px", marginBottom: "14px" }}>
        <Stack direction="row" spacing={2} alignItems="flex-start">
          <Box
            sx={{
              width: 52,
              height: 52,
              borderRadius: "12px",
              backgroundColor: "success.light",
              color: "success.main",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 18,
              fontWeight: 600,
              flexShrink: 0,
            }}
          >
            {initials(clientName)}
          </Box>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Stack direction="row" spacing={1.3} alignItems="center" flexWrap="wrap">
              <Typography sx={{ fontSize: 19, fontWeight: 700, letterSpacing: "-.3px" }}>
                {clientName}
              </Typography>
              {estado.label ? <StatusChip label={estado.label} tone={estado.tone} /> : null}
            </Stack>
            <Typography sx={{ fontSize: 12.5, color: "text.secondary", marginTop: "3px", fontFamily: monoFont }}>
              Crédito #{id}
              {dataCredit && dataCredit.client ? ` · Cédula ${dataCredit.client.identification}` : ""}
            </Typography>
          </Box>
          <Box sx={{ textAlign: "right", flexShrink: 0 }}>
            <Typography sx={{ fontSize: 11, color: "text.secondary", fontWeight: 500 }}>
              Estadística (prom. mora)
            </Typography>
            <Typography sx={{ fontFamily: monoFont, fontSize: 18, fontWeight: 600, color: "warning.main", marginTop: "2px" }}>
              {(dataCredit ? dataCredit.promedio : 0).toFixed(2)}
            </Typography>
          </Box>
        </Stack>
      </Paper>

      <Box sx={{ marginBottom: "16px" }}>
        <SegmentedTabs
          value={value}
          onChange={setValue}
          tabs={[
            { label: "Crédito", icon: <CreditCardRoundedIcon sx={{ fontSize: 17 }} /> },
            { label: "Garantías", icon: <HomeWorkRoundedIcon sx={{ fontSize: 17 }} /> },
            { label: "Plan de Pagos", icon: <CalendarMonthRoundedIcon sx={{ fontSize: 17 }} /> },
            { label: "Abonos", icon: <VolunteerActivismRoundedIcon sx={{ fontSize: 17 }} /> },
          ]}
        />
      </Box>

      {value === 0 && (
        <CreditDetails
          id={id}
          setClientName={setClientName}
          isNominal={isNominal}
          setIsNominal={setIsNominal}
          setDataCredit={setDataCredit}
        />
      )}
      {value === 1 && <CreditGarantias id={id} />}
      {value === 2 && (
        <CreditPayment id={id} clientName={clientName} isNominal={isNominal} dataCredit={dataCredit} />
      )}
      {value === 3 && <CreditAbono id={id} isNominal={isNominal} />}
    </div>
  );
};

export default CreditDetailsContainer;
